type Props = { onNavigate: (index: number) => void };

const STATS = [
  { value: "12+", label: "Years on the grid", grow: "flex-1" },
  { value: "05", label: "Industries covered", grow: "flex-1" },
  { value: "Java · Spring · AWS", label: "Home straight", grow: "flex-[1.4]" }
];

const HeroSection = ({ onNavigate }: Props) => (
  <section className="section-enter grid max-w-[1180px] grid-cols-[minmax(0,1fr)_300px] items-center gap-14">
    <div>
      <div className="mb-6 flex items-center gap-2.5">
        <span className="h-px w-[34px] bg-gradient-to-r from-transparent to-accent" />
        <span className="text-[10.5px] uppercase tracking-kicker text-accent-300">
          Backend engineering · Since 2013
        </span>
      </div>

      <h1 className="mb-4 font-heading text-[76px] font-medium leading-[1.02] tracking-[-0.03em]">
        Mario Dominguez
      </h1>

      <p className="mb-3 max-w-[640px] text-xl leading-[1.5] text-neutral-300">
        Sr. Software Engineer. I build the systems that keep the money, the
        policies, the billing, the bookings and the patients moving — fast,
        boring and hard to break.
      </p>

      <p className="mb-8 max-w-[600px] text-[15px] leading-[1.65] text-neutral-500 [text-wrap:pretty]">
        Twelve years across fintech, insurance, startups, hospitality, and
        healthcare. Still building — using AI to ship faster along the way.
      </p>

      <dl className="mb-9 flex max-w-[640px] gap-6 border-y border-white/[0.16] py-[18px]">
        {STATS.map((s) => (
          <div key={s.label} className={s.grow}>
            <dt className="sr-only">{s.label}</dt>
            <dd className="font-heading text-[26px] font-medium tabular-nums text-ink">
              {s.value}
            </dd>
            <dd className="mt-1 text-[10.5px] uppercase tracking-[0.16em] text-neutral-500">
              {s.label}
            </dd>
          </div>
        ))}
      </dl>

      <div className="flex gap-3">
        <button
          type="button"
          onClick={() => onNavigate(1)}
          className="rounded-md border border-accent px-[22px] py-[11px] text-[13.5px]
                     font-medium text-accent-300 transition-colors duration-200
                     hover:bg-accent-900/40 active:bg-accent-800/50"
        >
          See the track record →
        </button>
        <button
          type="button"
          onClick={() => onNavigate(5)}
          className="rounded-md border border-neutral-800 px-[22px] py-[11px] text-[13.5px]
                     font-medium text-neutral-300 transition-colors duration-200
                     hover:border-neutral-700 hover:text-ink"
        >
          Radio in
        </button>
      </div>
    </div>

    <div className="relative">
      <div className="absolute -inset-[18px] rounded-full bg-[radial-gradient(circle,rgba(145,132,217,0.22),transparent_68%)]" />
      <img
        src="/f1-pilot.jpg"
        alt="Mario Dominguez"
        className="relative aspect-square w-full rounded-lg border border-neutral-800 object-cover"
      />
      <div className="relative mt-3 flex justify-between text-[10.5px] uppercase tracking-[0.16em] text-neutral-500">
        <span>Driver 01</span>
        <span className="text-accent-300">Available</span>
      </div>
    </div>
  </section>
);

export default HeroSection;
